import React, { useState, useEffect } from "react";
import { useParams, useSearchParams, Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/contextAuth";
import LogoImg from "../assets/img/logo/Save-Logo-Blue-2.png";

const ResetPass = () => {
  const {
    error,
    loadingAuth,
    passwordReset,
    setResetPassword,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword
  } = useAuth();
  
  const { userId } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.backgroundImage =
      "radial-gradient(circle at center, #302158, #100021)";
    document.body.style.height = "100vh";
    document.body.style.margin = "0";
    document.body.style.overflow = "hidden";
  }, []);

  useEffect(() => {
    if (passwordReset) {
      const timer = setTimeout(() => navigate("/signin"), 3000);
      return () => clearTimeout(timer);
    }
  }, [passwordReset, navigate]);

  const handleReset = async (e) => {
    e.preventDefault();
    try {
      await setResetPassword(userId, password, confirmPassword, token);
    } catch (error) {
      console.error("Error resetting password:", error);
    }
  };

  return (
    <div className="position-fixed top-50 start-50 translate-middle w-100 d-flex justify-content-center">
      <div
        className="bg-white rounded-4 shadow-lg p-5"
        style={{ maxWidth: 420, width: "95%" }}
      >
        {/* Logo */}
        <div className="text-center mb-4">
          <img src={LogoImg} alt="Logo" height={50} />
        </div>

        {!passwordReset ? (
          <>
            {/* Header */}
            <div className="text-center mb-4">
              <h4 className="fw-bold text-dark">
                Create New Password
              </h4>
              <p className="text-secondary small">
                Choose a strong password to secure your account.
              </p>
            </div>

            {/* Form */}
            <form onSubmit={handleReset}>
              <div className="mb-3 position-relative">
                <label className="form-label small fw-semibold">
                  New Password
                </label>
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control rounded-3 bg-light pe-5"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="btn position-absolute top-50 end-0 my-3 translate-middle-y border-0 bg-transparent text-secondary"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? "👁️‍🗨️" : "👁️"}
                </button>
              </div>

              <div className="mb-3">
                <label className="form-label small fw-semibold">
                  Confirm New Password
                </label>
                <input
                  type="password"
                  className="form-control rounded-3 bg-light"
                  placeholder="••••••••"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </div>

              {error && (
                <div className="alert alert-danger small text-center">
                  {error}
                </div>
              )}

              <button
                type="submit"
                className="btn w-100 fw-bold rounded-3 mt-2"
                disabled={loadingAuth || !token}
                style={{
                  backgroundColor: "#0ea5e9",
                  color: "#fff",
                  padding: "12px"
                }}
              >
                {!token
                  ? "Invalid Link"
                  : loadingAuth
                  ? "Updating..."
                  : "Reset Password"}
              </button>
            </form>
          </>
        ) : (
          /* SUCCESS STATE */
          <div className="text-center py-4">
            <div
              className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4"
              style={{
                width: 80,
                height: 80,
                background: "#f0f9ff",
                color: "#0ea5e9",
                fontSize: "2rem"
              }}
            >
              ✓
            </div>

            <h4 className="fw-bold text-dark">
              Password Updated!
            </h4>

            <p className="text-secondary small">
              Your password has been changed successfully.
              <br />
              Redirecting you to sign in...
            </p>

            {/* Progress Bar */}
            <div className="progress mt-3" style={{ height: 4 }}>
              <div
                className="progress-bar"
                role="progressbar"
                style={{
                  width: "100%",
                  backgroundColor: "#0ea5e9",
                  animation: "progressAnim 3s linear forwards"
                }}
              />
            </div>

            <Link
              to="/signin"
              className="fw-bold text-decoration-none d-inline-block mt-3"
              style={{ color: "#0ea5e9" }}
            >
              Return to Sign In
            </Link>
          </div>
        )}
      </div>

      {/* Minimal animation */}
      <style>
        {`
        @keyframes progressAnim {
          from { width: 0%; }
          to { width: 100%; }
        }
      `}
      </style>
    </div>
  );
};

export default ResetPass;